import { AxiosResponse } from 'axios';

import { IUserDocument } from '../../shared/ts/document';
import httpRequest from '../httpRequest';

const userDocumentsAPI = {
  getUserDocuments: async (
    id: number,
    type: string[],
  ): Promise<IUserDocument[]> => {
    const { data } = (await httpRequest({
      url: `/document?user_id=${id}&${type.map(t => `type[]=${t}`).join('&')}`,
      method: 'GET',
    })) as AxiosResponse;

    return data;
  },
  postUserDocument: async (
    payload: IUserDocument,
    onProgress: (progressEvent: ProgressEvent) => void,
  ): Promise<IUserDocument> => {
    const { data } = (await httpRequest({
      url: payload.booking_id ? `/document/guest` : `/document`,
      method: 'POST',
      data: payload,
      onUploadProgress(progressEvent) {
        onProgress(progressEvent);
      },
    })) as AxiosResponse;

    return data;
  },
  deleteUserDocument: async (
    id: number,
    documentSide?: string,
    booking_id?: string,
  ): Promise<IUserDocument> => {
    const { data } = (await httpRequest(
      booking_id
        ? {
            url: `/document/guest/${id}${
              documentSide ? `?side=${documentSide}` : ''
            }`,
            method: 'DELETE',
            data: { booking_id },
          }
        : {
            url: `/document/${id}${
              documentSide ? `?side=${documentSide}` : ''
            }`,
            method: 'DELETE',
          },
    )) as AxiosResponse;

    return data;
  },
};

export default userDocumentsAPI;
